export class SubBrand {
  constructor(public subBrandId: number, public subBrandName: string) {}
}
